import { UPDATEPLAYING } from "./../constants/action_types.js";

export const setIsPlaying = (state) => async (dispatch) =>
{
  try
  {
    dispatch({ type: UPDATEPLAYING, payload: state });
  }
  catch (err)
  {
    console.trace(err);
  }
}
